import {
  chakraComponents,
  GroupBase,
  ValueContainerProps,
} from 'chakra-react-select';
import { Box } from '@chakra-ui/react';

export const ValueContainer = <Option extends {}>({
  children,
  ...props
}: ValueContainerProps<Option, false, GroupBase<Option>>) => (
  <chakraComponents.ValueContainer {...props}>
    <Box
      position="absolute"
      width={3}
      height="100%"
      right={3}
      background="linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, var(--chakra-color-bg) 100%)"
    />
    {children}
  </chakraComponents.ValueContainer>
);
